<template>
  <b-col cols="6" class="why-us-item-wrap col-lg mb-3 mb-lg-0">
    <div class="why-us-item-inner">
      <b-img :src="getIcon" :alt="getTitle" fluid />
      <h3 v-html="getTitle" />
      <hr />
      <p>{{ data.desc }}</p>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ["data", "idx"],
  data() {
    return {};
  },
  computed: {
    getTitle() {
      const textArr = this.data.title.split("");
      const firstWork = textArr.shift();
      return `<span class="text-danger">${firstWork}</span>${textArr.join("")}`;
    },
    getIcon() {
      return require(`@/assets/images/home/icon_${this.idx + 1}.png`);
    },
  },
};
</script>

<style lang="scss">
.why-us-item {
  &-wrap {
    text-align: center;
    h3 {
      color: $color-main;
    }
  }
  &-inner {
    padding: 15px;
    height: 100%;
    box-shadow: 0px 0px 10px #00000029;
    
    img {
      padding: 20px;
    }

    p {
      font-size: 14px;
      color: #595757
    }
  }
}
</style>